import { SVGProps } from 'react'

export const Write = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.0607 6.06066L17 2L7 12V16.0607H11.0607L21.0607 6.06066ZM8.5 14.5607V12.6213L17 4.12132L18.9393 6.06066L10.4393 14.5607H8.5ZM11 3.06066H2V21.0607H20V12.0607H18.5V19.5607H3.5V4.56066H11V3.06066Z"
      fill="currentColor"
    />
  </svg>
)

